//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as echarts from 'echarts';
import { Progress } from 'element-ui';
import { getAssetAllocation } from '@/api/member';
export default {
  name: 'OrderDialogAssetAllocation',
  components: {
    ElProgress: Progress,
  },
  props: {
    value: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      colorArr: ['#ff4040', '#fbb61e', '#386ff2'],
      detail: null,
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const data = await this.$axios(getAssetAllocation(this.value));
      this.detail = data.result;
      this.$nextTick(() => {
        const el = document.getElementById('asset-pie');
        if (el) {
          const option = {
            color: this.colorArr,
            series: [
              {
                type: 'pie',
                radius: ['40%', '70%'],
                itemStyle: {
                  borderColor: '#f7f8f9',
                  borderWidth: 2,
                },
                data: data.result.configurations.map(item => {
                  return {
                    name: item.name,
                    value: item.proportion,
                  };
                }),
              },
            ],
            grid: {
              y: 0,
              y2: 0,
            },
          };
          const charts = echarts.init(el);
          charts.setOption(option);
        }
      });
    },
  },
};
